export const v20Properties = [
  "date",
  "scheduledTime",
  "arrivalTimeFrom",
  "arrivalTimeTo",

  "senderName",
  "senderAddress",
  "senderBuildingNumber",
  "senderPhone",
  "senderEmail",
  "senderNote",

  "recipientName",
  "recipientAddress",
  "buildingNumber",
  "recipientPhone",
  "recipientEmail",
  "dropOffNote",

  "parcelValue",
  "parcelWeight",
  "parcelLength",
  "parcelHeight",
  "parcelWidth",

  "orderReferenceId",
]
